// [MCV-1759] Class names shared by the Account settings sections and
// AccountDeactivationSection, which sits in its own file.
//
// From `lg:` a section is two columns: heading and helper text on the left, its
// controls on the right. Below `lg:` the two wrappers just stack, which is the
// single-column layout each section had before. The panel fills the page, but
// each section tops out at 56rem and sits at the start, so labels and fields
// keep a readable width on a wide screen instead of stretching across it. The
// tracks are `minmax(0, …)` so a wide control can never push the right column
// past the panel.
export const SETTINGS_SECTION_CLASS =
  'flex flex-col gap-3 lg:grid lg:max-w-4xl lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)] lg:gap-x-10';
export const SETTINGS_INTRO_CLASS = 'flex flex-col gap-3';
export const SETTINGS_CONTROLS_CLASS = 'flex min-w-0 flex-col gap-3';

// A button that is not part of a form: the same right-aligned row FormActions
// gives a form's buttons from `sm:` up, without its top rule (there is no form
// body for it to close off).
export const SETTINGS_ACTION_ROW_CLASS = 'flex flex-col gap-3 sm:flex-row sm:justify-end sm:gap-4';
